import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=bb20eb98&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb20eb98')) {
      api.createRecord('bb20eb98', component.options)
    } else {
      api.reload('bb20eb98', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=bb20eb98&", function () {
      api.rerender('bb20eb98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CwgHlJIak6AM/JS/cancellationPolicy.vue"
export default component.exports